import { AppRoutes } from "@/shared/lib/routes"
import { LegalLink } from "@/shared/components/legal-link"
import moneyBackIcon from "@/features/offers/assets/icons/money-back.svg"

interface OfferDisclaimerProps {
  /**
   * Plan-aware consent sentence (trial / recurring / one-time), built from the
   * offer plan via `buildConsentDisclaimer` so a subscription offer states its
   * real rebill terms instead of a fixed one-time line.
   */
  consentText: string
}

/**
 * Money-back guarantee + charge consent, shown under the CTA only when the offer
 * plan is a recurring subscription (`one_time === false`). One-time offers omit
 * it. The consent copy comes from the plan; the badge + Terms link are fixed.
 */
export function OfferDisclaimer({ consentText }: OfferDisclaimerProps) {
  return (
    <div
      data-slot="offer-disclaimer"
      className="flex w-full flex-col items-center justify-center gap-2 rounded-[16px] border border-purple-light/10 p-4"
    >
      <div className="flex items-center justify-center gap-1 rounded-[20px] bg-purple-light/10 px-5 py-2">
        <img src={moneyBackIcon} alt="" className="h-[18px] w-[15px]" />
        <span className="text-sm font-semibold text-purple-light">100% money back guarantee</span>
      </div>
      <p className="text-center text-xs text-purple-light/40">
        {consentText} I have thoroughly reviewed and accepted the{" "}
        <LegalLink to={AppRoutes.TERMS} className="underline">
          Terms and Conditions
        </LegalLink>
      </p>
    </div>
  )
}
